import { TitleCasePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import {
  Answer,
  FieldInfo,
  Widget,
  Question,
  CodehelpService,
  InputType,
  ConfigMapService,
} from "virtue-form";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "src/app/core/services/shared/api.service";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";

@Component({
  selector: "app-widget",
  templateUrl: "./widget.component.html",
  styleUrls: ["./widget.component.scss"],
  providers: [TitleCasePipe],
})
export class WidgetComponent implements OnInit, OnChanges {
  @Output() inputwidgetoutput = new EventEmitter<Answer>();
  @Output() removewidgetInput = new EventEmitter<number>();
  @Output() validated = new EventEmitter<FieldInfo>();
  @Output() isInternational = new EventEmitter<boolean>(false);
  @Input() inputwidget: Widget | undefined;
  @Input() answerMap!: Map<Number, Answer>;
  @Input() showError = false;
  disableMap: Map<Number, boolean> = new Map();
  errorMessage: Array<string> = [];
  pageHeaderQuestion?: Question;
  widgetno: number = 0;
  defaultValues: string = "0";
  widgetTitle: string = "";
  calculatedQuestionArray: Array<Question> = [];
  constructor(
    private checkUserLogin: CheckLoginSessionService,
    private codehelp: CodehelpService,
    private titlecasePipe: TitleCasePipe,
    private globalVar: GlobalVarService,
    private configmap: ConfigMapService
  ) {}

  ngOnInit(): void {
    this.pageHeaderQuestion = this.inputwidget?.headerQuestion;

    this.widgetno = this.inputwidget?.widgetNo || 0;
    this.checkWidgetVisibility();
  }

  checkWidgetVisibility() {
    let hidden = false;
    if (this.inputwidget) {
      hidden = this.codehelp.checkVisibilityCondition(
        this.inputwidget,
        this.answerMap,
        this.inputwidget?.visibilityCondition?.visibleType
      );
      if (!hidden) {
        this.widgetTitle = this.inputwidget?.widgetTitle || "";
        this.calculateQuestion();
      } else {
        // Added to remove all answer from hidden widget on 8 march 22 by Mridu
        if (this.inputwidget.questions) {
          this.inputwidget.questions.forEach((question, index) => {
            if (this.answerMap.get(question.fieldNo)) {
              this.removeinput(question.fieldNo);
              this.addFieldasValid(question.fieldNo);
            }
          });
        }
      }
    }
  }

  calculateAge(dateString: string) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  checkStringContainsNumeric(str: string) {
    let matchPattern = str.match(/\d+/g);
    if (matchPattern != null) {
      return true;
    } else {
      return false;
    }
  }

  calculateQuestion() {
    let apicall = false;
    // this.spinnerService.show();
    this.calculatedQuestionArray = [];
    // let dis= false;
    let householdFieldValue = "false";
    let totallivinhousehold = 1;
    const qus = this.inputwidget?.questions;
    if (qus)
      qus.forEach((question, index) => {
        const tagIndex = this.widgetno * 100 + index + 1;
        this.globalVar.tagIndexMap.set(question.fieldNo, tagIndex);
        const ans = this.answerMap.get(question.fieldNo);
        if (ans && question.configId && !ans?.configId) {
          ans.configId = question.configId;
          this.changeinput(ans);
        }
        const parent1Amount = this.answerMap.get(217)?.value;
        const parent2Amount = this.answerMap.get(218)?.value;
        const parentTaxAmount = this.answerMap.get(216)?.value;
        const getParentsMaritalStatus = this.answerMap.get(206);

        // if (question.fieldNo === 217) {
        //   if (parentTaxAmount)
        //     this.setSubline(Number(parentTaxAmount), question.validation?.minValue || 0, question);
        //   if (getParentsMaritalStatus?.value == 'married') {
        //     if (parent1Amount && parentTaxAmount) {
        //       var maxValue: number = 0;
        //       if (parent2Amount) {
        //         const parentIncome = Number(parent1Amount?.toString()) + Number(parent2Amount?.toString());
        //         if (parentIncome > Number(parentTaxAmount?.toString())) {
        //           maxValue = Number(parentTaxAmount?.toString());
        //           this.setSubline(maxValue, question.validation?.minValue || 0, question);
        //         }
        //       } else {
        //         if (
        //           Number(parent1Amount?.toString()) >
        //           Number(parentTaxAmount?.toString())
        //         ) {
        //           maxValue = Number(parentTaxAmount?.toString());
        //           this.setSubline(maxValue, question.validation?.minValue || 0, question);
        //         }
        //       }
        //     }
        //   } else if (parent1Amount && parentTaxAmount) {
        //     var maxValue: number = 0;
        //     if (Number(parent1Amount?.toString()) > Number(parentTaxAmount?.toString())) {
        //       maxValue = Number(parentTaxAmount?.toString());
        //       this.setSubline(maxValue, question.validation?.minValue || 0, question);
        //     }
        //   }
        // }

        // if (question.fieldNo === 218) {
        //   const parent1Amount = this.answerMap.get(217)?.value;
        //   const parent2Amount = this.answerMap.get(218)?.value;
        //   const parentTaxAmount = this.answerMap.get(216)?.value;
        //   if (parentTaxAmount) {
        //     if (parent1Amount) {
        //       const num = Number((Number(parentTaxAmount) - Number(parent1Amount)).toFixed(2));
        //       if (num > 0)
        //         this.setSubline(num, question.validation?.minValue || 0, question);
        //       else
        //         this.setSubline(999999999, question.validation?.minValue || 0, question);
        //     } else
        //       this.setSubline(Number(parentTaxAmount), question.validation?.minValue || 0, question);
        //   }
        // }
        if (question?.fieldNo == 41) {
          const US_Citizen = this.answerMap.get(41);
          if (US_Citizen) {
            if (US_Citizen.value == "no") {
              this.isInternational.emit(true);
              let removeList = [6, 40, 99999];
              removeList.forEach((fieldNo) => {
                this.removeinput(fieldNo);
              });
            } else {
              this.isInternational.emit(false);
              this.removeinput(238);
            }
          }
        }
        if (question.fieldNo === 35) {
          const categoryvalue = this.answerMap.get(35)?.value;
          if (categoryvalue) {
            question.defaultValue = categoryvalue;
          }
        }

        if (question.fieldNo === 219) {
          const parentTaxAmount = this.answerMap.get(216)?.value;
          if (parentTaxAmount)
            this.setSubline(
              Number(parentTaxAmount),
              question.validation?.minValue || 0,
              question
            );
        }
        if (question.fieldNo === 99999) {
          const getAnswerState = this.answerMap.get(6);
          // this.defaultValues=element.defaultValue;
          // const getStateGrant = this.answerMap.get(99999);
          // if (getStateGrant?.value){
          const st = getAnswerState?.value;
          this.configmap.getVirtueConfigData(
            `state_code_link_${st}`,
            8889898,
            (resp) => {
              if (resp.length) {
                question.moreInfo.link = resp[0].value;
                if (resp[0]?.altValue) {
                  question.defaultValue = resp[0].altValue;
                } else {
                  question.defaultValue = this.defaultValues;
                }
              } else {
                question.defaultValue = this.defaultValues;
                question.moreInfo.link =
                  "https://studentaid.gov/help-center/answers/article/state-aid";
              }
            }
          );
          apicall = true;
          // }
        }

        if (question.fieldNo === 209) {
          const studentIncomeTaxAmount = this.answerMap.get(209)?.value;
          const studentTotalIncomeAmount = this.answerMap.get(207)?.value;
          if (studentTotalIncomeAmount)
            this.setSubline(
              Number(studentTotalIncomeAmount),
              question.validation?.minValue || 0,
              question
            );
          if (studentIncomeTaxAmount && studentTotalIncomeAmount) {
            var maxValue: number = 0;
            if (
              Number(studentIncomeTaxAmount?.toString()) >
              Number(studentTotalIncomeAmount?.toString())
            ) {
              maxValue = Number(studentTotalIncomeAmount?.toString());
              this.setSubline(
                maxValue,
                question.validation?.minValue || 0,
                question
              );
            }
          }
        }
        // if (question.fieldNo === 208) {
        //   const studentWorkAmount = this.answerMap.get(208)?.value;
        //   const AGIAmount = this.answerMap.get(207)?.value;
        //   const spouseTotalIncomeAmount = this.answerMap.get(228)?.value;
        //   if (AGIAmount)
        //     this.setSubline(Number(AGIAmount), question.validation?.minValue || 0, question);
        // }
        // if (question.fieldNo === 228) {
        //   const AGIAmount = this.answerMap.get(207)?.value;
        //   const studentIncome = this.answerMap.get(208)?.value;
        //   if (AGIAmount){
        //     if(studentIncome){
        //       const num = Number((Number(AGIAmount) - Number(studentIncome)).toFixed(2));
        //       if (num > 0)
        //         this.setSubline(num, question.validation?.minValue || 0, question);
        //       else
        //         this.setSubline(999999999, question.validation?.minValue || 0, question);
        //     }
        //     else
        //       this.setSubline(Number(AGIAmount), question.validation?.minValue || 0, question);
        //   }
        // }

        if (question.fieldNo === 239) {
          const getAnswerState = this.answerMap.get(6);
          const getAnswerCounty = this.answerMap.get(265);
          if (getAnswerCounty) {
            if (
              question.configId != `county_${getAnswerCounty?.altValue}_zipcode`
            )
              question.configId = `county_${getAnswerCounty?.altValue}_zipcode`;
          } else if (getAnswerState) {
            if (question.configId != `state_${getAnswerState?.value}_zipcode`)
              question.configId = `state_${getAnswerState?.value}_zipcode`;
          }
        }
        if (question.fieldNo === 240) {
          const getAnswerDob = this.answerMap.get(264);
          if (getAnswerDob) {
            const year = this.codehelp.formatDate(getAnswerDob.value, "YYYY");
            // console.log(year);
            if (question.configId != `graduationYear@${year}`)
              question.configId = `graduationYear@${year}`;
          }
        }
        //to calculate coounty config
        if (question.fieldNo === 265) {
          const getAnswerState = this.answerMap.get(6);
          if (getAnswerState) {
            if (
              question.configId !=
              "state_" + getAnswerState?.value + "_county"
            ) {
              question.configId = "state_" + getAnswerState?.value + "_county";
            }
          }
        }
        // to set parent age greater than student
        if (question.fieldNo === 225) {
          const getAnswerDob = this.answerMap.get(264);
          if (getAnswerDob?.value) {
            const age = this.calculateAge(getAnswerDob?.value);
            if (age > 0) {
              question.validation = {
                minValue: age,
                maxValue: 150,
                errorMessage: question.validation?.errorMessage || "",
                regex: null,
              };
              if (question.display.subLine) {
                if (this.checkStringContainsNumeric(question.display.subLine)) {
                  question.display.subLine = question.display.subLine.replace(
                    /\d+/g,
                    age.toString()
                  );
                }
              }
            }
          }
        }
        if (question.fieldNo === 232) {
          totallivinhousehold = 1;
          const getAnswerstudenttype = this.answerMap.get(269);
          const getstudenttype = getAnswerstudenttype?.value;
          switch (getstudenttype) {
            case "Dependent": {
              ++totallivinhousehold;
              const studentMaritalStatus = this.answerMap.get(11)?.value;
              const parentMaritalStatus = this.answerMap.get(206)?.value;
              // const getAnswerstudenttype = this.answerMap.get(269);
              if (studentMaritalStatus === "married") ++totallivinhousehold;
              if (parentMaritalStatus === "married") ++totallivinhousehold;
              break;
            }
            case "IndependentWithoutDependents": {
              const studentMaritalStatus = this.answerMap.get(11)?.value;
              if (studentMaritalStatus === "married") ++totallivinhousehold;
              break;
            }
            case "IndependentWithDependents": {
              const studentMaritalStatus = this.answerMap.get(11)?.value;
              const numberofindependent = this.answerMap.get(244)?.value;
              if (studentMaritalStatus === "married") ++totallivinhousehold;
              if (numberofindependent)
                totallivinhousehold =
                  totallivinhousehold + Number(numberofindependent);
              break;
            }
            default: {
              break;
            }
          }
          let errormsg = question.validation?.errorMessage || "";
          if (
            (question.validation?.errorMessage &&
              this.checkStringContainsNumeric(
                question.validation?.errorMessage
              )) ||
            ""
          ) {
            errormsg =
              question.validation?.errorMessage.replace(
                /\d+/g,
                totallivinhousehold.toString()
              ) || "";
          }
          let dTooltip = question.display.tooltip || "";
          if (
            (question.display.tooltip &&
              this.checkStringContainsNumeric(question.display.tooltip)) ||
            ""
          ) {
            dTooltip =
              question.display.tooltip.replace(
                /\d+/g,
                totallivinhousehold.toString()
              ) || "";
          }
          question.validation = {
            minValue: totallivinhousehold,
            maxValue: 0,
            errorMessage: errormsg, //'Min value should be '+totallivinhousehold,
            regex: null,
          };
          const ansHousehold = this.answerMap.get(232);
          if (ansHousehold) {
            // console.log(ansHousehold);
            if (
              totallivinhousehold < Number(ansHousehold.value) &&
              ((totallivinhousehold == 2 && question.defaultValue == "3") ||
                (totallivinhousehold == 3 && question.defaultValue == "2"))
            ) {
              // if(Number(ansHousehold.value) <4)
              ansHousehold.value = totallivinhousehold + "";
              this.changeinput(ansHousehold);
            }
          }
          question.defaultValue = totallivinhousehold + "";

          question.display.tooltip = dTooltip; //question.display.tooltip.replace(/%d/g, totallivinhousehold.toString());//`Minimum value ${totallivinhousehold}`;
          // this.setSubline(totallivinhousehold, question);

          totallivinhousehold = Math.floor(totallivinhousehold);
          question.validation = {
            minValue: totallivinhousehold,
            maxValue: question.validation.maxValue,
            errorMessage: question.validation.errorMessage,
            regex: null,
          };
          if (question.display.subLine) {
            question.display.subLine = question.display.subLine.replace(
              /%d/g,
              totallivinhousehold.toString()
            );
            if (this.checkStringContainsNumeric(question.display.subLine)) {
              question.display.subLine = question.display.subLine.replace(
                /\d+/g,
                totallivinhousehold.toString()
              );
            }
            // this.setSubline(question.validation?.maxValue|| 0, totallivinhousehold, question);
          }
        }
        if (question.fieldNo === 232 && this.answerMap.get(232)) {
          // to calculate numOfHouseholdAttendingCollege
          const map = this.answerMap.get(232);
          householdFieldValue = map?.value || "1";
        }

        if (question.fieldNo === 231 && householdFieldValue != "false") {
          // to change numOfHouseholdAttendingCollege
          let ansdata = this.answerMap.get(231);
          const max = Number(householdFieldValue);

          let errormsg = question.validation?.errorMessage || "";
          if (
            (question.validation?.errorMessage &&
              this.checkStringContainsNumeric(
                question.validation?.errorMessage
              )) ||
            ""
          ) {
            errormsg =
              question.validation?.errorMessage.replace(
                /\d+/g,
                max.toString()
              ) || "";
          }
          let dTooltip = question.display.tooltip || "";
          if (
            (question.display.tooltip &&
              this.checkStringContainsNumeric(question.display.tooltip)) ||
            ""
          ) {
            dTooltip =
              question.display.tooltip.replace(/\d+/g, max.toString()) || "";
          }

          question.validation = {
            minValue: 1,
            maxValue: max,
            errorMessage: errormsg, //'Number should be less than '+max,
            regex: null,
          };
          question.display.tooltip = dTooltip; //`Number should be less than ${max}`;
        }

        if (question.fieldNo === 240) {
          // When will/did you graduate from high school?
          const answerenrolment = this.answerMap.get(235);
          if (answerenrolment?.value === "transfer") {
            question.display.label =
              " When did you graduate from high school? ";
            question.display.tooltip =
              " When did you graduate from high school? ";
          } else if (answerenrolment?.value === "freshman") {
            question.display.label =
              " When will you graduate from high school? ";
            question.display.tooltip =
              " When will you graduate from high school? ";
          }
        }

        this.checkLabelChanges(question);
        // this.checkTooltipChanges(question)

        if (question?.visibilityCondition?.visibleType === "SHOWN") {
          const hidden = this.codehelp.checkVisibilityCondition(
            question,
            this.answerMap,
            "SHOWN"
          );
          if (!hidden) {
            this.calculatedQuestionArray.push(question);
          } else {
            if (this.answerMap.get(question.fieldNo))
              this.removeinput(question.fieldNo);
            this.addFieldasValid(question.fieldNo);
          }
        } else if (question?.visibilityCondition?.visibleType === "HIDDEN") {
          const shown = this.codehelp.checkVisibilityCondition(
            question,
            this.answerMap,
            "SHOWN"
          );
          if (!shown) {
            if (this.answerMap.get(question.fieldNo))
              this.removeinput(question.fieldNo);
            this.addFieldasValid(question.fieldNo);
          } else {
            this.calculatedQuestionArray.push(question);
          }
        } else {
          this.calculatedQuestionArray.push(question);
        }
        if (question?.visibilityCondition?.visibleType === "DISABLED") {
          const shown = this.codehelp.checkVisibilityCondition(
            question,
            this.answerMap,
            "DISABLED"
          );
          if (!shown) {
            // disable true add in map
            this.disableMap.set(question?.fieldNo, true);
          } else {
            this.disableMap.set(question?.fieldNo, false);
          }
        }

        //this.spinnerService.hide();
      });
  }

  getConfigId(qus: Question) {
    if (qus.fieldNo === 239) {
      const getAnswerState = this.answerMap.get(6);
      const getAnswerCounty = this.answerMap.get(265);

      if (getAnswerCounty) {
        if (qus.configId != `county_${getAnswerCounty?.value}_zipcode`)
          qus.configId = `county_${getAnswerCounty?.value}_zipcode`;
      } else if (getAnswerState) {
        if (qus.configId != `state_${getAnswerState?.value}_zipcode`)
          qus.configId = `state_${getAnswerState?.value}_zipcode`;
      }
    }
    if (qus?.configConditions.length) {
      const condiotionValue = this.codehelp.checkConfigCondition(
        qus?.configConditions,
        this.answerMap,
        ""
      );
      if (condiotionValue) {
        return condiotionValue;
      } else {
        return qus.configId;
      }
    } else {
      return qus.configId;
    }
    //
  }

  ngOnChanges() {
    this.checkWidgetVisibility();
  }

  checkLabelChanges(question: Question) {
    const studentMargAnswer = this.answerMap.get(11);
    let label = question.display.label;
    const endStaticString = label.substring(
      label.indexOf("}") + 1,
      label.length
    );
    const startStaticString = label.substring(0, label.indexOf("{"));
    if (label.includes("{") && label.includes("}")) {
      let labelSub = label.substring(
        label.indexOf("{") + 1,
        label.lastIndexOf("}")
      );
      if (labelSub.includes("@") && labelSub.includes("_")) {
        const labelSplit = labelSub.split("_");
        const answerMapForKey = this.answerMap.get(Number(labelSplit[0]));
        const toReplaceString = labelSub.split("@");
        const hasQuestionMark = question.display.label.substring(
          question.display.label.length - 1
        );
        if (answerMapForKey) {
          let ansVal = this.titlecasePipe.transform(answerMapForKey.value);
          if (ansVal.charAt(ansVal.length - 1) === "s") {
            if (hasQuestionMark === "?") ansVal = `${ansVal}`;
            else ansVal = `${ansVal}'`;
          } else {
            if (hasQuestionMark === "?") ansVal = `${ansVal}`;
            else ansVal = `${ansVal}'s`;
          }
          if (question.fieldNo === 207 || question.fieldNo === 6666) {
            if (studentMargAnswer?.value == "married") {
              ansVal = ansVal + " & spouse's";
            }
          }
          labelSub = `${labelSplit[0]}_${ansVal}@${toReplaceString[1]}`;
          question.display.label = `${startStaticString}{${labelSub}}${endStaticString}`;
        } else {
          // labelSub = `${toReplaceString[0]}@Student's`;
          // labelSub = `${toReplaceString[0]}@Student's`;
          labelSub = `${labelSplit[0]}_value@${toReplaceString[1]}`;
          question.display.label = `${startStaticString}{${labelSub}}${endStaticString}`;
        }
        // console.log(" question.display.label", question.display.label)
      }
    }
  }

  checkTooltipChanges(question: Question) {
    let label = question.display.tooltip;
    const endStaticString = label.substring(
      label.indexOf("}") + 1,
      label.length
    );
    const startStaticString = label.substring(0, label.indexOf("{"));
    if (label.includes("{") && label.includes("}")) {
      let labelSub = label.substring(
        label.indexOf("{") + 1,
        label.lastIndexOf("}")
      );
      if (labelSub.includes("@") && labelSub.includes("_")) {
        const labelSplit = labelSub.split("_");
        const answerMapForKey = this.answerMap.get(Number(labelSplit[0]));
        if (answerMapForKey) {
          const toReplaceString = labelSub.split("@");
          let ansVal = this.titlecasePipe.transform(answerMapForKey.value);
          if (ansVal.charAt(ansVal.length - 1) === "s") {
            ansVal = `${ansVal}'`;
          } else {
            ansVal = `${ansVal}'s`;
          }
          labelSub = `${toReplaceString[0]}@${ansVal}`;
          question.display.tooltip = `${startStaticString}{${labelSub}}${endStaticString}`;
        }
      }
    }
  }

  formValid(ev: FieldInfo) {
    this.validated.emit(ev);
  }

  changeinput(op: Answer) {
    if (this.checkUserLogin.CheckUserSession() == false) {
      this.checkUserLogin.onLogout("");
    } else {
      if (op.value) {
        this.answerMap.set(op.fieldNo, op);
        this.inputwidgetoutput.emit(op);
        this.checkWidgetVisibility();
      }
    }
  }

  addFieldasValid(fieldNo: number) {
    let ev: FieldInfo = {};
    ev[fieldNo] = "valid";
    this.formValid(ev);
  }

  setSubline(maxval: number, minValue: number, question: any) {
    question.validation = {
      minValue: minValue,
      maxValue: maxval,
      errorMessage: question.validation.errorMessage,
      regex: null,
    };
    // maxval = Math.floor(maxval);

    // var sublin= question.display.subLine;// "sdcf scd _1_ ds sd";
    // var splitpan = sublin.split('_');
    // splitpan[1]= maxval;
    // if(maxval == 999999999)
    //   splitpan[1]= 0;

    // sublin = '';
    // for(let i=0;i<splitpan.length ;i++){
    //   if(i < splitpan.length-1)
    //   sublin = sublin + splitpan[i]+'_';
    //   else
    //   sublin = sublin + splitpan[i];
    // }
    // question.display.subLine = sublin;
  }

  errorInput(error: string) {
    let edata = error.split(":");
    if (edata.length > 0) {
      if (edata[0] == "add" && this.errorMessage.indexOf(edata[1]) == -1) {
        this.errorMessage.push(edata[1]);
      } else if (
        edata[0] == "rem" &&
        this.errorMessage.indexOf(edata[1]) != -1
      ) {
        this.errorMessage.splice(this.errorMessage.indexOf(edata[1]), 1);
      } else if (edata[0] == "rem" && edata[1] == "") {
        this.errorMessage.splice(this.errorMessage.indexOf(edata[1]), 1);
      }
    }
  }

  getDisabled(qus: Question) {
    const val = this.disableMap.get(qus.fieldNo);
    return val;
  }

  removeinput(key: number) {
    this.answerMap.delete(key);
    this.removewidgetInput.emit(key);
  }

  getValue(qus: Question) {
    const val = this.answerMap.get(qus.fieldNo);
    return val?.value || "";
  }

  getaltValue(qus: Question) {
    const val = this.answerMap.get(qus.fieldNo);
    return val?.altValue || "";
  }

  getClassforAutoSearch(info: Question) {
    if (info.display.inputType == InputType.AUTO_COMPLETE) {
      return "zdex-dn";
    } else return "";
  }
}
